// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/alert_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { AlertService } from "./alert_service_pb";

/**
 * @generated from rpc inventory.v1.AlertService.ListAlerts
 */
export const listAlerts = AlertService.method.listAlerts;

/**
 * @generated from rpc inventory.v1.AlertService.GetAlert
 */
export const getAlert = AlertService.method.getAlert;

/**
 * @generated from rpc inventory.v1.AlertService.UpdateAlertStatus
 */
export const updateAlertStatus = AlertService.method.updateAlertStatus;

/**
 * Set or clear the per-alert manual severity override. Clearing falls back
 * to winning_rule.engine_severity → signal_type.default_level.
 *
 * @generated from rpc inventory.v1.AlertService.UpdateManualSeverity
 */
export const updateManualSeverity = AlertService.method.updateManualSeverity;
